"use strict";

module.exports = function () {
    this.currentUrl = window.location.pathname + window.location.search;
};


//////////////////
// WEBPACK FOOTER
// /home/giant/builds/t1_QpaSbS/0/kpmg/plan-k.cz/node_modules/swup/lib/modules/getUrl.js
// module id = 42
// module chunks = 3